<template>
  <div class="form-tags" v-if="tags">
    <span class="badge badge-primary" v-for="(tag, index) in tags" :key="index"> {{tag.text}} </span>
  </div>
</template>

<script>
export default {
  name: 'tags',
  props: ['tags'],
};
</script>
